import { combineReducers } from 'redux';
// Import your reducers here
import micrositeReducer from './micrositeReducer';

const rootReducer = combineReducers({
  microsite: micrositeReducer,
  // Add other reducers here
});

export default rootReducer;